<template>
  <!-- <div v-bind:style="{display:tabledata.length>0?'block':'none'}" > -->
  <div v-if="tabledata.length > 0">
    <p style="font-weight: bold; font-size: 1.5em">{{ tabletitle }}</p>

    <vuetable
      ref="vuetable"
      :fields="tablefields"
      :api-mode="false"
      :data="tabledata"
      :css="{ tableClass: 'table table-sm table-hover' }"
      no-data-template
    >
      <span slot="sq" slot-scope="props">{{ props.rowIndex + 1 }}</span>
      <status
        slot="status"
        slot-scope="props"
        :rowData="props.rowData"
        :rowField="props.rowField"
      ></status>
      <span slot="remove" slot-scope="props">
        <el-button
          type="warning"
          size="mini"
          @click="removeitem(props.rowIndex)"
          >X</el-button
        >
      </span>
    </vuetable>

    <div v-if="tabledata.length != 0">
      <el-button v-if="printoutobj" @click="downloadpdf">下载pdf</el-button>
      <el-button v-if="datatoexcelobj" @click="datastoexcel">下载excel</el-button>
      <el-button v-if="datatoqrcodeobj" @click="datatoqrcode">下载QRCODE</el-button>
    </div>

    <div
      style="margin-bottom: 50px; background-color: rgba(0, 0, 0, 0.2)"
      v-if="tabledata.length === 0"
    >
      <p style="font-size:2em;font-weight:bold">无数据</p>
    </div>
  </div>
</template>

<script>
import Vuetable from "vuetable-2";

import { fieldsprocess } from "zxg-table-fieldsprocess";
import status from "@/components/utility/commonfields/status";


export default {
  components: {
    Vuetable,
    status,
  },
  props: ["collection", "tabletitle"],
  data() {
    return {
      processing: false,
      //   tabledata: [],
      //   tablefields: []
    };
  },
  computed: {
    datatoexcelobj(){
      return this.$store.state.currentheader.find(obj=>{
        return obj.name=="datatoexcel"
      })
    },
    datatoqrcodeobj(){
      return this.$store.state.currentheader.find(obj=>{
        return obj.name=="datatoqrcode"
      })
    },
    printoutobj(){
      return this.$store.state.currentheader.find(obj=>{
        return obj.name=="printout" && !obj.fake
      })
    },
    tablefields() {
      return fieldsprocess(this.$store.state.currentheader,"printaspdf",this.$store)//extendedfields(this.$store.state.currentheader);
    },
    tabledata() {
      return this.$store.state.prints;
    },
  },
  //   mounted() {
  //     this.$axios
  //       .post(url + "singleclct", { collection: this.collection })
  //       .then(res => {
  //         this.tablefields = extendedfields(res.data.fields);
  //         this.tabledata = res.data.doc;
  //         if (res.data.doc.length > 0) {
  //           this.$emit("hasdata");
  //         }
  //       });
  //   },
  methods: {
    datatoqrcode(){
      // let datas={data:this.$store.state.prints[0].datatoexcel,docs:this.$store.state.prints}
      this.$axios
        .post(
          url + "datatoqrcode",
          {
            formname:this.datatoqrcodeobj.formname||"",
            qrtitle:this.datatoqrcodeobj.qrtitle,
            columnno:this.datatoqrcodeobj.columnno,
            collection:this.$store.state.collection.value,
            items:this.$store.state.prints,

          },
          {
            responseType: "blob",
          }
        )
        .then((res) => {
          let src = URL.createObjectURL(res.data);
          let link = document.createElement("a");
          link.download = "qrcodedownload" + ".pdf";
          link.href = src;
          link.click();

          this.$store.commit("resetitems", "prints");
          this.$router.push("/");
        });
    },
    datastoexcel() {
      
      let template=this.datatoexcelobj.template
      // let datas={data:this.$store.state.prints[0].datatoexcel,docs:this.$store.state.prints}
      this.$axios
        .post(
          url + "datastoexcel",
          { template: template, datas:this.$store.state.prints },
          {
            responseType: "blob",
          }
        )
        .then((res) => {
          let src = URL.createObjectURL(res.data);
          let link = document.createElement("a");
          link.download = "download" + ".xlsx";
          link.href = src;
          link.click();

          this.$store.commit("resetitems", "prints");
          this.$router.push("/");
        });
    },

    downloadpdf() {
      let firstone = JSON.stringify(this.$store.state.prints[0].receivers);
      let checkconsistency = true;
      this.$store.state.prints.forEach((obj) => {
        if (JSON.stringify(obj.receivers) != firstone) {
          this.$message(
            "打印项目审批状态不一致To make sure approval status consistent"
          );
          checkconsistency = false;
        }
      });
      if (checkconsistency) {
        this.$axios.downloadpdf(
          this.$store.state.user,
          this.$store.state.collection.value,
          this.$store.state.prints
        );
        this.$store.commit("resetitems", "prints");
        this.$router.push("/");
      }
    },

    removeitem(index) {
      this.$store.commit("removeitem", { where: "prints", itemindex: index });
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/print/printaspdf.vue